import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import useAntibodyMetadata from 'molbio/antibody-engineering/useAntibodyMetadata';
import {
  getAntibodyVisibilitySettings,
  shouldShowAntibodyTools,
} from 'molbio/antibody-engineering/visibilityHelpers';
import {VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';
import Tooltip from 'ui-library/bs/Tooltip';
import {ORANGE_DARK} from 'ui-library/Colors';

export default function AntibodyToolsMetadata({
  aminoAcids,
  visibilityOptions,
}: {
  aminoAcids: string;
  visibilityOptions: VisibilityOptions;
}): JSX.Element {
  const [numberingScheme, cdrDefinition] = getAntibodyVisibilitySettings(visibilityOptions);
  const [antibodyMessage, organismInfo] = useAntibodyMetadata(aminoAcids, numberingScheme, cdrDefinition);

  if (!shouldShowAntibodyTools(visibilityOptions)) {
    return <></>;
  }
  return (
    <div className={css(styles.antibodyMetadataContainer)}>
      {antibodyMessage && (
        <Tooltip title={antibodyMessage}>
          <span className={css(styles.antibodyMessage)}>{antibodyMessage}</span>
        </Tooltip>
      )}
      {organismInfo && (
        <Tooltip title="Antibody Chain(s) (Best Match)">
          <span className={css(styles.organismInfo)}>{organismInfo}</span>
        </Tooltip>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  antibodyMetadataContainer: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: 15,
    paddingBottom: 2,
  },
  antibodyMessage: {
    color: ORANGE_DARK,
  },
  organismInfo: {
    marginLeft: 5,
  },
});
